import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import RouteConfig from './router/RouteConfig';

const App = () => {
  return (
    <React.Fragment>
      <Router>
        <RouteConfig />
      </Router>
    </React.Fragment>
  );
};

export default App;
